import { Divider, Flex, Form } from "antd";
import GerarLinkPagamentoFormBasic, { IGerarLinkPagamentoFormBasicProps } from "./GerarLinkPagamentoFormBasic";
import { IGerarLinkPagamentoInscricaoParams, useInscricaoBuscarPorCodigo } from "@/Services/Domain/Viagem/InscricaoService";
import CarregamentoComponentes from "@/Components/Base/Carregamento";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
type IGerarLinkPagamentoFormBasicPropsOp = Partial<Omit<IGerarLinkPagamentoFormBasicProps, "inscricao">> & { codInscricao : number; };
export interface IGerarLinkPagamentoFormProps extends IGerarLinkPagamentoFormBasicPropsOp {
    children?: () => React.ReactNode;
}
export default function GerarLinkPagamentoForm({ 
    form: formParam,
    children,
    codInscricao,
    ...rest 
}: IGerarLinkPagamentoFormProps) {
    const [newForm] = Form.useForm<IGerarLinkPagamentoInscricaoParams>();
    const form = formParam ?? newForm;

    const {
        data,
        isFetching,
        isLoading
    } = useInscricaoBuscarPorCodigo({
        codInscricao: codInscricao
    });

    if (!(isFetching || isLoading) && data === undefined) return <>Inscrição não encontrada.</>;

    return <TelaCarregamento ativo={isFetching || isLoading}>
        <>
            <GerarLinkPagamentoFormBasic
                form={form}
                inscricao={data ?? {}}
                {...rest} 
            />
            {children && <>
                <Divider />
                <Flex gap="small" wrap="wrap" justify="center">
                    children
                </Flex>
            </>}
        </>
    </TelaCarregamento>;    
}